import {get,post} from "../Api.js";
import config from "../config";
import {getCookie} from '../../untils/common.js'
import axios from 'axios'
const {baseUrl} = config

// 用户详情
function getUserSig (params) {
  return get(`${baseUrl}/student/userSig`, params);
}
export {
	getUserSig
}



// WEBPACK FOOTER //
// ./src/net/im/index.js